module.exports = __webpack_public_path__ + "static/img/default.47c32652.png";